module.exports = "/images/home-1.png";